function ContentAreaController(
  PackageService,
  CommonService,
  DescriptorService,
  toasterService,
  userService,
  $uibModal,
  $interval,
  __env
) {
  const ctrl = this;
  const checkNullLength = CommonService.checkNullLength;
  const getPackageHeader = DescriptorService.getPackageHeader;

  ctrl.$onInit = () => {
    ctrl.packageAvailable = false;
    ctrl.activatePackageAvailableModule = false;
    ctrl.getPackages();
    ctrl.hasFileUploadToTrain = userService.hasFileUploadToTrain();
    ctrl.hasReadTrainParameter = userService.hasReadTrainParameter();
    ctrl.moduleUploadStatusIdentifier = undefined;
    ctrl.moduleUploadStatusLog = [];
    ctrl.progressStatusPromise = $interval(ctrl.triggerModuleUploadStatusUpdate, 5000);
    ctrl.hasPackageActivation = __env.profile !== 'VALE';
  };
  ctrl.$onDestroy = () => {
    $interval.cancel(ctrl.progressStatusPromise);
  };

  // Runs everytime module or car is changed
  ctrl.$onChanges = changes => {
    if (changes.selection && ctrl.train && changes.selection.currentValue.id) {
      ctrl.moduleUploadStatusIdentifier = {
        trainId: ctrl.train.status.trainId,
        carNumber: ctrl.carNumber,
        moduleId: changes.selection.currentValue.id
      };
      ctrl.triggerModuleUploadStatusUpdate();
    }

    // Reset the sanctioned package highlighting
    if (changes.selection) {
      ctrl.packageHighlight = false;
      ctrl.updateHighlight = false;
    }

    if (ctrl.selection && ctrl.availablePackages && ctrl.carNumber) {
      ctrl.checkForAvailablePackages();
    }
    // Re-process version descriptors only when ctrl.selection
    // changes.
    if (changes.selection) {
      ctrl.hasIO = checkForIO(ctrl.selection);
      ctrl.checkForUploadPackages();
      ctrl.processVersionDescriptors();
    }

    if (ctrl.selection) {
      ctrl.filteredProgressList = ctrl.filterProgressList(ctrl.progressList, ctrl.carNumber);
      if (ctrl.filteredProgressList) {
        ctrl.activeProgress = ctrl.filteredProgressList.find(p => p.phase !== 'ready');
      }
      ctrl.thisModuleProgress = ctrl.checkProgressStatus(ctrl.filteredProgressList);
    }

    // Set upgrade flags only when a module is selected
    if (ctrl.selection && !ctrl.selection.car_number) {
      ctrl.upgradeFlagHardware = ctrl.getUpgradeStatusHardware();
      ctrl.upgradeFlagSoftware = ctrl.getUpgradeStatusSoftware();
    }
  };

  ctrl.triggerModuleUploadStatusUpdate = () => {
    if (ctrl.moduleUploadStatusIdentifier) {
      PackageService.getPackageUploadStatusList(
        ctrl.moduleUploadStatusIdentifier.trainId,
        ctrl.moduleUploadStatusIdentifier.carNumber,
        ctrl.moduleUploadStatusIdentifier.moduleId
      ).then(data => {
        ctrl.moduleUploadStatusLog = data;
      });
    }
  };

  const checkForIO = selectionObject => {
    if (!selectionObject || !selectionObject.module_family_name) return false;
    return (selectionObject.module_family_name.includes('RIM') || selectionObject.module_family_name.includes('ROM') || selectionObject.module_family_name.includes('RID')) || selectionObject.module_family_name.includes('EIO') ? true : false;
  };

  ctrl.getPackages = () => {
    PackageService.getAllPackages().then(data => {
      ctrl.availableSoftwarePackages = data;
    });
  };

  ctrl.getUpgradeStatusHardware = () => {
    if (ctrl.selection.hw_upgrade_available && ctrl.selection.hw_upgrade_available.date_created > ctrl.selection.hardware_version_date_created) {
      if (ctrl.selection.hw_upgrade_available.version_number !== ctrl.selection.hardware_version) {
        return true;
      }
    }
    return false;
  };

  ctrl.getUpgradeStatusSoftware = () => {
    let upgradeStatus = false;
    if (ctrl.selection.sw_upgrade_available && ctrl.selection.sw_upgrade_available.length > 0) {
      ctrl.selection.sw_upgrade_available.forEach(module => {
        if (
          module.descriptor === 'Engineering' &&
          ctrl.selection.software_version_status === 'Engineering' ||
          ctrl.selection.software_version_status === 'Valid' ||
          ctrl.selection.software_version_status === 'Sanctioned'
        ) {
          if (
            module.date_created > ctrl.selection.software_version_date_created &&
            module.version_number !== ctrl.selection.software_version
          ) {
            upgradeStatus = true;
          }
        } else if (
          module.descriptor === 'Sanctioned' &&
          ctrl.selection.software_version_status === 'Sanctioned'
        ) {
          upgradeStatus = false;
        } else if (
          module.descriptor === 'Valid' &&
          ctrl.selection.software_version_status === 'Valid' ||
          ctrl.selection.software_version_status === 'Engineering' ||
          ctrl.selection.software_version_status === 'Sanctioned'
        ) {
          upgradeStatus = false;
        } else {
          if (module.version_number !== ctrl.selection.software_version) {
            upgradeStatus = true;
          }
        }
      });
    }
    return upgradeStatus;
  };

  ctrl.checkForUploadPackages = () => {
    ctrl.validPackagesForUpload = [];
    ctrl.packageAvailable = false;
    if (ctrl.selection && ctrl.availableSoftwarePackages && ctrl.availableSoftwarePackages.length > 0 ) {
      ctrl.availableSoftwarePackages.forEach(pkg => {
        let headerObject = getPackageHeader(pkg);
        if (ctrl.selection.module_family_name && ctrl.selection.module_family_name === headerObject.module_family_name) {
          ctrl.selection.packages_available.forEach(module => {
            if (module.version_number === headerObject.version) {
              ctrl.packageAvailable = true;
              ctrl.validPackagesForUpload.push(pkg);
            }
          });
        }
      });
      ctrl.preProcessPackages(ctrl.validPackagesForUpload);
    }
  };

  ctrl.preProcessPackages = packages => {
    if (!ctrl.descriptors || !packages || packages.length === 0) return;
    let packageHeader = getPackageHeader(packages[0]);
    const moduleDescriptors = ctrl.descriptors.filter(obj => obj.type === packageHeader.module_family_name);
    if (moduleDescriptors.length && moduleDescriptors[0].sw_revision.length) {
      moduleDescriptors[0].sw_revision.forEach(revision => {
        packages.forEach(pkg => {
          let packageHeader = getPackageHeader(pkg);
          if (packageHeader.version === revision.version_number) {
            pkg.descriptor = revision.status;
            if (pkg.descriptor === 'Sanctioned') {
              ctrl.packageHighlight = true;
            }
          }
        });
      });
    }
  };

  // filterAvailablePackages :: ([Object], Integer) -> [Object]
  const filterAvailablePackages = (packagesList, carNumber) =>
    packagesList.filter(p => (p.status !== 'Deprecated' && p.status !== 'Unknown' && p.status !== null) && carNumber == p.source);

  // filterModulePackages :: ([Object], String) -> [Object]
  const filterModulePackages = (packagesList, name) =>
    packagesList.filter(p => p.moduleType === name);

  const checkInstallParent = (packages, selection) => packages.filter(p => p.topologyId === selection.parent_installation_id);

  ctrl.checkForAvailablePackages = () => {
    ctrl.activatePackageAvailableModule = false;
    ctrl.activatePackageAvailableCar = false;

    ctrl.packagesInCar = filterAvailablePackages(ctrl.availablePackages, ctrl.carNumber);
    ctrl.validPackages = checkInstallParent(ctrl.packagesInCar, ctrl.selection);
    ctrl.thisModulePackages = filterModulePackages(ctrl.validPackages, ctrl.selection.module_family_name);

    ctrl.updateHighlight = ctrl.validPackages.some(p => p.status === 'Sanctioned');

    if (ctrl.packagesInCar.length > 0) {
      ctrl.activatePackageAvailableCar = true;
    }

    if (ctrl.thisModulePackages.length > 0) {
      ctrl.activatePackageAvailableModule = true;
    }
  };

  // filterProgressList :: ([Object], Integer) -> [Object]
  ctrl.filterProgressList = (progressList, carNumber) => {
    return checkNullLength(progressList)
      .fold(e => null,
        c => c.filter(obj => obj.carNumber == carNumber));
  };

  // checkProgressStatus :: ([Object]) -> Object
  ctrl.checkProgressStatus = filteredProgressList => {
    return checkNullLength(filteredProgressList)
      .fold(e => null,
        c => c.find(item => item.moduleType === ctrl.selection.module_family_name));
  };

  ctrl.canUpdatePackage = () => {
    if (__env.profile === 'VALE') {
      return true;
    } else {
      return ctrl.train.status.mode === 'ON_DEPOT' || ctrl.train.status.mode === 'ON_DEPOT_MAINTENANCE';
    }
  };

  ctrl.openUpdateModal = () => {
    let modalInstance = $uibModal.open({
      component: 'softwareUpdateModal',
      backdrop: 'static',
      resolve: {
        packages: function () {
          return ctrl.validPackagesForUpload;
        },
        train: function () {
          return ctrl.train;
        },
        carNumber: function () {
          return ctrl.carNumber;
        },
        topologyId: function () {
          return ctrl.selection.id;
        },
        descriptors: function () {
          return ctrl.descriptors;
        },
      },
    });

    modalInstance.result.then(
      uploadObject => {
        // User pressed 'Upload' in the modal.
        PackageService.uploadPackage(uploadObject).then(
          function (response) {
            ctrl.onUpload();
            toasterService.success('toaster.package-upload-event', 'toaster.package-upload-start-success');
          },
          function (e) {
            toasterService.error('toaster.package-upload-event', 'toaster.package-upload-start-failure');
            console.log(e);
          }
        );
      },
      () => {
        // User pressed 'Cancel' in the modal, do nothing.
      }
    );
  };

  ctrl.openActivationModal = mode => {
    let modalInstance = $uibModal.open({
      component: 'softwareActivationModal',
      resolve: {
        packages: function () {
          return mode === 'car' ? ctrl.packagesInCar : ctrl.thisModulePackages;
        },
        train: function () {
          return ctrl.train;
        },
        carNumber: function () {
          return ctrl.carNumber;
        },
        descriptors: function () {
          return ctrl.descriptors;
        },
        mode: function () {
          return mode;
        },
      },
    });

    modalInstance.result.then(
      activationObject => {
        // User pressed 'Activate' in the modal.
      },
      () => {
        // User pressed 'Cancel' in the modal, do nothing.
      }
    );
  };

  ctrl.processVersionDescriptors = () => {
    if (ctrl.selection && !ctrl.selection.car_number) {
      if (ctrl.selection.status === 0) {
        ctrl.warningActive = true;
      } else {
        ctrl.warningActive = false;
      }
    } else if (ctrl.selection && ctrl.selection.car_number) {
      if (ctrl.selection.moduleHealthNotification) {
        ctrl.warningActive = true;
      } else {
        ctrl.warningActive = false;
      }
    }
  };
}

angular
  .module('configuration-management.module')
  .controller('ContentAreaController', ContentAreaController);
